<template>
  <div class="container">
    <div>
      <img style="width: 50px; height: 50px" src="../../assets/img/loading.gif" alt="" />
    </div>
  </div>
</template>

<script>

export default {
  data() {
    return {
    }
  },
  created() { },
  mounted() {
     window.location.href = 'https://apps.apple.com/app/id1631363552'
  },
  methods: {

  }
}
</script>

<style lang="less">
.container {
  width: 100%;
  text-align: center;
  margin-top: 35vh;
}
</style>
